import { MessageCircle, Users, Database, Table2, Mail, Plug, Archive } from "lucide-react";
import { Reveal, Overline } from "@/components/Reveal";

const tools = [
  { label: "WhatsApp", icon: MessageCircle },
  { label: "CRM", icon: Users },
  { label: "ERP", icon: Database },
  { label: "Planilhas", icon: Table2 },
  { label: "E-mail", icon: Mail },
  { label: "APIs", icon: Plug },
  { label: "Sistemas legados", icon: Archive },
];

export const Solution = () => {
  return (
    <section id="solution" className="relative py-28 md:py-40 border-t border-white/5 bg-[#070707]">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="max-w-[60ch]">
          <Reveal>
            <Overline>A solução</Overline>
            <h2 className="font-display font-extrabold text-3xl md:text-5xl tracking-tight leading-[1.05] mt-6">
              Não troque sua empresa inteira para automatizá-la.
            </h2>
            <p className="text-neutral-400 text-lg leading-relaxed mt-8">
              Criamos a camada que conecta sua operação atual e transforma
              tarefas repetitivas em processos controlados.
            </p>
            <p className="text-neutral-300 text-base leading-relaxed mt-4 max-w-[54ch]">
              Mantemos o que já funciona e automatizamos a comunicação e a
              execução entre as partes.
            </p>
          </Reveal>
        </div>

        {/* Architecture diagram */}
        <Reveal delay={0.15}>
          <div className="mt-20 grid lg:grid-cols-[1fr_auto_1fr] gap-8 lg:gap-6 items-center">
            {/* left tools */}
            <div className="grid grid-cols-2 gap-3">
              {tools.slice(0, 4).map((t, i) => (
                <ToolChip key={i} {...t} align="left" />
              ))}
            </div>

            {/* central node */}
            <div className="relative flex items-center justify-center py-8">
              <div className="relative h-44 w-44 md:h-52 md:w-52 rounded-full border border-white/15 flex items-center justify-center">
                <span className="absolute inset-0 rounded-full border border-white/10 animate-[ping_3s_ease-in-out_infinite]" />
                <div className="h-24 w-24 md:h-28 md:w-28 rounded-full bg-white text-black flex flex-col items-center justify-center text-center">
                  <span className="font-display font-extrabold text-sm leading-tight px-2">
                    Camada de
                    <br />
                    automação
                  </span>
                </div>
              </div>
            </div>

            {/* right tools */}
            <div className="grid grid-cols-2 gap-3">
              {tools.slice(4).map((t, i) => (
                <ToolChip key={i} {...t} align="right" />
              ))}
              <div className="col-span-2 rounded-sm border border-dashed border-white/10 p-4 text-center">
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-600">
                  + seus processos
                </span>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

const ToolChip = ({ label, icon: Icon }) => (
  <div className="group flex items-center gap-3 rounded-sm border border-white/10 bg-[#0a0a0a] p-4 hover:border-white/25 transition-colors">
    <Icon className="h-5 w-5 text-neutral-400 group-hover:text-white transition-colors" strokeWidth={1.4} />
    <span className="font-mono text-xs text-neutral-300">{label}</span>
  </div>
);
